export default "__VITE_ASSET__903aabed__"